import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Login.css';

const FLASHAID_LOGO_URL = "https://storage.googleapis.com/flash-v2/assets/images/logo.png";

const Login = ({ setAuthenticated }) => {
  const navigate = useNavigate();

  const [contactNumber, setContactNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);

  // which button is loading: "send" | "verify" | null
  const [loadingAction, setLoadingAction] = useState(null);

  // lightweight modal
  const [modal, setModal] = useState({ open: false, message: "" });
  const openModal = (message) => setModal({ open: true, message });
  const closeModal = () => setModal({ open: false, message: "" });

  const handleSendOtp = async () => {
    const phone = contactNumber.replace(/\D/g, '').slice(0, 10);
    if (phone.length !== 10) {
      openModal('Please enter your 10-digit mobile number');
      return;
    }

    try {
      setLoadingAction('send');
      await axios.post(
        `https://flashaid-v3-prod-backend.flashaid.in/auth/v1/tirumala/generate-otp?phoneNumber=${phone}`
      );
      setIsOtpSent(true);
    } catch (error) {
      console.error('Error sending OTP:', error);
      openModal('Failed to send OTP. Please try again.');
    } finally {
      setLoadingAction(null);
    }
  };

  const handleLogin = async () => {
    const phone = contactNumber.replace(/\D/g, '').slice(0, 10);
    if (phone.length !== 10 || otp.replace(/\D/g, '').length !== 6) {
      openModal('Enter a valid 10-digit mobile number and 6-digit OTP.');
      return;
    }

    try {
      setLoadingAction('verify');

      const verifyotp = await axios.post(
        `https://flashaid-v3-prod-backend.flashaid.in/auth/v1/tirumala/verify-otp?phoneNumber=${phone}&otp=${otp}`
      );

      if (verifyotp?.data?.message === "OTP verified success") {
        sessionStorage.setItem('isAuthenticated', 'true');
        setAuthenticated(true);

        const PartnerLoginResponse = await axios.post(
          'https://flashaid-v3-prod-backend.flashaid.in/auth/v1/userdata/login-userid',
          { userName: 'FLASH28781', password: 'Vo82pwejEf' },
          { headers: { 'Content-Type': 'application/json' } }
        );

        sessionStorage.setItem('userData', JSON.stringify(PartnerLoginResponse.data));
        navigate('/generate-lead');
      } else {
        // show modal instead of alert
        openModal('Invalid OTP. Please try again.');
      }
    } catch (error) {
      console.error("Login Error:", error);
      openModal('Something went wrong during login. Please try again.');
    } finally {
      setLoadingAction(null);
    }
  };

  return (
    <>
      {/* Tiny modal */}
      {modal.open && (
        <div className="mini-modal-overlay" onClick={closeModal}>
          <div className="mini-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="mini-modal-close" onClick={closeModal} aria-label="Close">×</button>
            <div className="mini-modal-body">{modal.message}</div>
            <button className="mini-modal-ok" onClick={closeModal}>OK</button>
          </div>
        </div>
      )}

      <div className="login-page">
        <img
          className="login-page-image"
          src={FLASHAID_LOGO_URL}
          alt="Flashaid Logo"
        />

        <div className="login-container">
          <h2 className="login-title">Enter Contact Number</h2>

          <input
            type="text"
            placeholder="Enter your 10 digit mobile number"
            className="login-input"
            style={{ fontFamily: '"Josefin Sans", sans-serif' }}
            value={contactNumber}
            onChange={(e) =>
              setContactNumber(e.target.value.replace(/\D/g, '').slice(0, 10))
            }
          />

          <button
            className={`login-button ${loadingAction === 'send' ? 'btn-loading' : ''}`}
            style={{ fontFamily: '"Josefin Sans", sans-serif' }}
            onClick={handleSendOtp}
            disabled={loadingAction !== null}
          >
            {loadingAction === 'send' ? (
              <>
                <span className="btn-spinner" /> Sending...
              </>
            ) : (
              isOtpSent ? 'Resend OTP' : 'Send OTP'
            )}
          </button>

          {isOtpSent && (
            <>
              <input
                type="text"
                placeholder="Enter OTP"
                className="login-input"
                style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              />

              <button
                className={`login-button ${loadingAction === 'verify' ? 'btn-loading' : ''}`}
                style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                onClick={handleLogin}
                disabled={loadingAction !== null}
              >
                {loadingAction === 'verify' ? (
                  <>
                    <span className="btn-spinner" /> Verifying...
                  </>
                ) : (
                  'Verify OTP'
                )}
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Login;
